export default __webpack_public_path__ + "static/lower1_3-0bb8ce4e1bd23fba09ebc88659914081.jpg";